/* eslint-disable indent */
import { Component, Input } from '@angular/core';
import { Modal, ModalOptions } from 'flowbite';

@Component({
  selector: 'app-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.scss'],
})
export class CreateOrderComponent {
  @Input({
    required: true,
  })
  action!: () => Promise<void> | void;
  @Input({})
  disabledButton = false;
  @Input({})
  showButton!: boolean;
  @Input({
    required: true,
  })
  closeModal!: () => Promise<void> | void;
  modal!: Modal;
  options: ModalOptions = {
    placement: 'bottom-right',
    backdrop: 'dynamic',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
    closable: true,
  };

  constructor() {}

  ngAfterViewInit() {
    const $targetElement = document.getElementById('CreateOrderModal');
    this.modal = new Modal($targetElement, this.options);
  }

  open() {
    this.modal.show();
  }

  async close() {
    await this.closeModal();
    this.modal.hide();
  }

  async onClickAction() {
    await this.action();
    this.modal.hide();
  }
}
